import { z } from "zod";

import { addToListsTargetSchema } from "@/lib/add-to-lists-target";

export const addToListsIntentSchema = z.object({
  target: addToListsTargetSchema,
  preferredListType: z.enum(["collection", "wishlist"]).optional(),
});

export type AddToListsIntent = z.infer<typeof addToListsIntentSchema>;
